export const SupervisedLearningIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.5C8.76885 5.49998 5.43733 7.42677 3.12194 11.49C2.94177 11.8062 2.94177 12.1936 3.12194 12.5098C5.43733 16.5731 8.76886 18.4999 12 18.4999C15.2312 18.4999 18.5627 16.5732 20.8781 12.5099C21.0583 12.1937 21.0583 11.8063 20.8781 11.4901C18.5627 7.42687 15.2312 5.50002 12 5.5ZM12 4C15.8792 4.00003 19.6579 6.31907 22.1814 10.7475C22.6239 11.524 22.6239 12.476 22.1814 13.2526C19.6579 17.681 15.8791 20 12 19.9999C8.12092 19.9999 4.34216 17.6809 1.81869 13.2524C1.37619 12.4759 1.37619 11.5239 1.81869 10.7474C4.34216 6.31896 8.12093 3.99997 12 4Z"
        fill="#737373"
      />
      <path
        d="M10.7412 10.5176L11.5528 8.89443C11.7371 8.5259 12.263 8.5259 12.4473 8.89443L13.2588 10.5176C13.3072 10.6144 13.3857 10.6928 13.4824 10.7412L15.1056 11.5528C15.4741 11.737 15.4741 12.263 15.1056 12.4472L13.4824 13.2588C13.3857 13.3072 13.3072 13.3856 13.2588 13.4824L12.4473 15.1056C12.263 15.4741 11.7371 15.4741 11.5528 15.1056L10.7412 13.4824C10.6929 13.3856 10.6144 13.3072 10.5176 13.2588L8.89446 12.4472C8.52594 12.263 8.52594 11.737 8.89447 11.5528L10.5176 10.7412C10.6144 10.6928 10.6929 10.6144 10.7412 10.5176Z"
        fill="#737373"
      />
    </svg>
  );
};
